export default function Landing({ isDark }) {
  return (
    <section
      style={{
        minHeight: "10vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "40px",
        backgroundColor: isDark ? "#000" : "#fff",
        color: isDark ? "#fff" : "#000",
      }}
    >
      <div>
        {/* Main Heading */}
        <h1
          style={{
            fontSize: "36px",
            fontWeight: "600",
            marginBottom: "8px",
            lineHeight: "1.2",
          }}
        >
          Your One-Stop Hub for Frontend Components
        </h1>

        {/* Sub text */}
        <p
          style={{
            fontSize: "19px",
            color: isDark ? "#9ca3af" : "#6b7280",
            lineHeight: "1.5",
            marginBottom: "20px",
          }}
        >
          Beautiful components. Clean code. Zero unnecessary complexity.
          <br />
          Completely open source — because great tools should be shared.
        </p>

        {/* Browse Button */}
        <button
          style={{
            backgroundColor: isDark ? "#fff" : "#000",
            color: isDark ? "#000" : "#fff",
            padding: "4px 10px",
            borderRadius: "8px",
            border: "none",
            fontSize: "15px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
        + Browse
        </button>
        <span
          style={{
            backgroundColor: isDark ? "white":"#e8e9eb" ,
            color: isDark ?  "#000" : "#000" ,
            padding: "6px 10px",
            borderRadius: "10px",
            border: "none",
            fontSize: "15px",
            fontWeight: "600",
            marginLeft: "10px",
          }}
        >
Made Wiith Love ❤️      </span>



      </div>

      
    </section>
    
  );
}
